import {useMainContext} from "../contexts/main";
import {useSocketContent} from "../contexts/socket-content";
import {useTradePrice} from "../contexts/trade-price";
import {useEffect, useState} from "react";
import {concatOrders} from "../utils/orderBook";
import { TABLET_SIZE } from "../constants/common";
import { useWindowSize } from "./common/useWindowSize";


const useOrdersBook = () => {

    const {width} = useWindowSize()
    const { market } = useMainContext()
    const { buyOrders, sellOrders } = useSocketContent()
    const { setTradePrice } = useTradePrice()
    const [loading, setLoading] = useState(true)

    const [_sellOrders, setSellOrders] = useState(null)
    const [_buyOrders, setBuyOrders] = useState(null)
    const [_max, setMax] = useState({ buy: 0, sell: 0 })

    const [sellHoverDetails, setSellHoverDetails] = useState({
        avg: null, sum: null, total: null
    })

    const [buyHoverDetails, setBuyHoverDetails] = useState({
        avg: null, sum: null, total: null
    })

    const [buyHover, setBuyHover] = useState(-1)
    const [sellHover, setSellHover] = useState(-1)

    useEffect(() => {
        if (market) {
            setBuyOrders(null)
            setSellOrders(null)
        }
    }, [market])

    // concat buy orders
    useEffect(() => {
        if (buyOrders) setBuyOrders(concatOrders(buyOrders))
    }, [buyOrders])

    useEffect(() => {
        if (sellOrders) setSellOrders(concatOrders(sellOrders))
    }, [sellOrders])

    useEffect(() => {
        setLoading(!buyOrders && !sellOrders)
    }, [buyOrders, sellOrders])

    useEffect(() => {
        if (_buyOrders) {
            const buy = Math.max(..._buyOrders.slice(0, 15).map(o => o.price))
            setMax(state => ({ ...state, buy }))
        }
    }, [_buyOrders])


    useEffect(() => {
        if (_sellOrders) {
            const sell = Math.max(..._sellOrders.slice(0, 15).map(o => o.price))
            setMax(state => ({ ...state, sell }))
        }
    }, [_sellOrders])


    const onBuyOrdersHover = (idx) => {
        setBuyHover(idx)
        let sum = 0;
        let total = 0;
        let avgTotal = 0;
        for (let i = 0; i < idx + 1; i++) {
            const curr = _buyOrders[i]
            total += curr.price
            sum += curr.amount
            avgTotal += curr.priceUnit
        }
        const avg = avgTotal / (idx + 1)
        setBuyHoverDetails({ avg, sum, total })
    }

    const onSellOrdersHover = (idx) => {
        setSellHover(idx)
        let sum = 0;
        let total = 0;
        let avgTotal = 0;
        for (let i = 0; i < (Math.min(_sellOrders.length, width > TABLET_SIZE ? 15 : 5)) - idx; i++) {
            const curr = _sellOrders[i]
            total += curr.price
            sum += curr.amount
            avgTotal += curr.priceUnit
        }
        const avg = avgTotal / (_sellOrders.length - idx)
        setSellHoverDetails({ avg, sum, total })
    }


    const onOrderClicked = (type, price) => {
        if (market.pair === "irt") {
            setTradePrice(state => ({ ...state, [type === "buy" ? "sell" : "buy"]: price, type }))
        } else {
            setTradePrice(state => ({ ...state, value: price, type }))
        }
    }

    return {
        _sellOrders, _buyOrders,
        sellHover, buyHover,
        setSellHover, setBuyHover,
        sellHoverDetails, buyHoverDetails,
        onSellOrdersHover, onBuyOrdersHover,
        _max, onOrderClicked, loading
    }
}


export default useOrdersBook;
